import React, { useState } from 'react';
import Breadcrumbs from '../common/Breadcrumbs';
import TimeStamp from '../common/TimeStamp';
import Row from '../common/Row';
import FieldIndex from '../fields/FieldIndex';
import FieldsetEdit from './FieldsetEdit';
import { Marked } from '../common/Marked';
import Icon from '../common/Icon';
import { handleDestroyFieldset } from './constants/handleFieldset';
import { useLoaderData, useNavigate, Link } from 'react-router-dom';

const FieldsetShow = () => {
  const { data } = useLoaderData();
  const navigate = useNavigate();
  const [fieldset, setFieldset] = useState(data.fieldset);
  const { form, fields } = data.fieldset;
  const [editing, setEditing] = useState(false);
  const [informantID, setInformantID] = useState(data.informant);

  const {
    comment,
    conditional_text,
    conditional_type,
    created_at,
    description,
    display_name,
    id,
    name,
    updated_at,
  } = fieldset;

  const toggleEdit = (e) => {
    e ? e.preventDefault() : null;
    setEditing(!editing);
  };

  const handleDestroy = async () => {
    await handleDestroyFieldset(id, (response) => {
      if (response.ok) {
        navigate(`/manage/forms/${form.id}/edit`);
      }
    });
  };

  return (
    <>
      <Breadcrumbs
        form={form}
        container={form.container}
        fieldset={{ name: name, id: id }}
      />

      {editing ? (
        <FieldsetEdit
          fieldset={fieldset}
          toggleEdit={toggleEdit}
          setFieldset={setFieldset}
          form={form}
        />
      ) : (
        <>
          <div className='details'>
            <div className='controls'>
              <Icon className='edit' onClick={toggleEdit} icon='pencil' />
              <Icon className='destroy' onClick={handleDestroy} icon='trash' />
            </div>
            <Row name='Display Name:' value={display_name} />
            <Row name='Name:' value={name} />
            <Row name='Comment:' value={comment} />
            <Row name='Description:' value={<Marked text={description} />} />
            <Row name='Conditional Text:' value={conditional_text} />
            {conditional_text && (
              <Row
                name='Conditional Type:'
                value={conditional_type ? conditional_type : 'checkbox'}
              />
            )}
            <TimeStamp title='Created' value={created_at} />
            <TimeStamp title='Updated' value={updated_at} />
            <Row name='Form:'>
              <Link to={`/manage/forms/${form.id}`}>{form.name}</Link>
            </Row>
          </div>
        </>
      )}

      <FieldIndex
        fields={fields}
        fieldset={fieldset}
        informantID={informantID}
        setInformantID={setInformantID}
      />
    </>
  );
};

export default FieldsetShow;
